export function initMinimalMenu() {
    $(window).scroll(function () {
        if ($(this).scrollTop() > $('.header').innerHeight()) {
            $('.minimal-menu').slideDown(300);
        } else {
            $('.minimal-menu').slideUp(300);
        }
    });
}
